// ** React Imports
import { useEffect, useState } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

// ** Store & Actions Imports
import { useDispatch, useSelector } from 'react-redux'
import { selectMessage, fetchUserProfile, fetchChatsContacts, removeSelectedChat } from 'src/store/apps/facebook'

// ** Hooks
import { useSettings } from 'src/@core/hooks/useSettings'

// ** Utils Imports
import { getInitials } from 'src/@core/utils/get-initials'
import { formatDateToMonthShort } from 'src/@core/utils/format'

// ** Chat App Components Imports
import LineSideBar from 'src/@core/components/facebook/facebook-side-bar'
import LineContent from 'src/@core/components/facebook/facebook-content'
import LineTelephone from 'src/@core/components/facebook/facebook-call'
import LineContacts from 'src/@core/components/facebook/facebook-contacts'
import ContentLoading from 'src/components/ContentLoading'
import Image from 'next/image'
import { Icon } from '@iconify/react'

const callData = {
  calls: [
    {
      id: 1,
      name: 'Aiden',
      img: '/images/avatars/1.png',
      icon: 'fluent:call-inbound-16-filled',
      time: 'Nov 11, 08:41 pm',
      Time: '19s',
      state: -1
    },
    {
      id: 2,
      name: 'Jacob ',
      img: '/images/avatars/2.png',
      icon: 'fluent:call-inbound-16-filled',
      time: 'Nov 11, 08:41 pm',
      Time: '19s',
      state: -1
    },
    {
      id: 3,
      name: 'Ethan ',
      img: '/images/avatars/3.png',
      icon: 'fluent:call-outbound-16-filled',
      time: 'Nov 11, 08:41 pm',
      Time: '40s',
      state: 1
    },
    {
      id: 4,
      name: 'Caden ',
      img: '/images/avatars/4.png',
      icon: 'fluent:call-inbound-16-filled',
      time: 'Nov 11, 08:39 pm',
      Time: '20s',
      state: -1
    },
    {
      id: 5,
      name: 'Jackson ',
      img: '/images/avatars/5.png',
      icon: 'fluent:call-inbound-16-filled',
      time: 'Nov 11, 08:25 pm',
      Time: '34s',
      state: -1
    },
    {
      id: 6,
      name: 'Smith ',
      img: '/images/avatars/6.png',
      icon: 'fluent:call-outbound-16-filled',
      time: 'Nov 11, 08:10 pm',
      Time: '19s',
      state: 1
    },
    {
      id: 7,
      name: 'Smith',
      img: '/images/avatars/6.png',
      icon: 'fluent:call-outbound-16-filled',
      time: 'Nov 11, 08:12 pm',
      Time: '41s',
      state: 1,
      State: false
    },
    {
      id: 8,
      name: 'Sammy ',
      img: '/images/avatars/8.png',
      icon: 'fluent:call-outbound-16-filled',
      time: 'Nov 11, 07:41 pm',
      Time: '59s',
      state: 1
    },
    {
      id: 9,
      name: 'Jacob',
      img: '/images/avatars/2.png',
      icon: 'fluent:call-outbound-16-filled',
      time: 'Nov 11, 07:00 pm',
      Time: '10s',
      state: 1
    },
    {
      id: 10,
      name: 'Jackson',
      img: '/images/call-log/5.webp',
      icon: 'fluent:call-inbound-16-filled',
      time: 'Nov 11, 05:00 pm',
      Time: '45s',
      state: -1
    },
    {
      id: 11,
      name: 'Aiden',
      img: '/images/avatars/1.png',
      icon: 'fluent:call-outbound-16-filled',
      time: 'Nov 11, 04:50 pm',
      Time: '1m 25s',
      state: 1
    }
  ],
  contacts: [
    {
      id: 1,
      name: 'Sarah',
      img: '/images/avatars/2.png'
    },
    {
      id: 2,
      name: 'Jacob',
      img: '/images/avatars/2.png'
    },
    {
      id: 3,
      name: 'Ethan',
      img: '/images/avatars/3.png'
    },
    {
      id: 4,
      name: 'Caden',
      img: '/images/avatars/4.png'
    },
    {
      id: 5,
      name: 'Jackson',
      img: '/images/avatars/5.png'
    },
    {
      id: 6,
      name: 'Smith',
      img: '/images/avatars/6.png'
    },
    {
      id: 7,
      name: 'Johny',
      img: '/images/avatars/7.png'
    },
    {
      id: 8,
      name: 'Sammy',
      img: '/images/avatars/8.png'
    },
    {
      id: 9,
      name: 'Olivia',
      img: '/images/call-log/2.webp'
    },
    {
      id: 11,
      name: 'Aiden',
      img: '/images/avatars/1.png'
    },
    {
      id: 12,
      name: 'Billie',
      img: '/images/call-log/4.webp'
    },
    {
      id: 13,
      name: 'Green',
      img: '/images/call-log/8.webp'
    },
    {
      id: 14,
      name: 'Cameron',
      img: '/images/avatars/4.png'
    },
    {
      id: 15,
      name: '+6180650048',
      img: '/images/avatars/5.png'
    },
    {
      id: 16,
      name: '+6176429832',
      img: '/images/avatars/6.png'
    },
    {
      id: 17,
      name: '+6145575780',
      img: '/images/avatars/7.png'
    },
    {
      id: 18,
      name: '+6105280088',
      img: '/images/avatars/8.png'
    },
    {
      id: 19,
      name: 'Sarah',
      img: '/images/avatars/2.png'
    },
    { id: 21, name: 'Rebecca', img: '/images/call-log/11.webp' },
    {
      id: 22,
      name: 'Amy',
      img: '/images/avatars/1.png'
    }
  ]
}

const Facebook = () => {
  // ** States
  const [userStatus, setUserStatus] = useState('online')
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(false)
  const [userProfileLeftOpen, setUserProfileLeftOpen] = useState(false)
  const [userProfileRightOpen, setUserProfileRightOpen] = useState(false)

  // ** Hooks
  const theme = useTheme()
  const { settings } = useSettings()
  const dispatch = useDispatch()
  const hidden = useMediaQuery(theme.breakpoints.down('lg'))

  const store = useSelector(state => state.Facebook)

  // ** Vars
  const { skin } = settings
  const smAbove = useMediaQuery(theme.breakpoints.up('sm'))
  const sidebarWidth = smAbove ? 370 : 300
  const mdAbove = useMediaQuery(theme.breakpoints.up('md'))

  const [chat, setChat] = useState(true)
  const [calls, setCalls] = useState(false)
  const [headImg, setHaedImg] = useState('/images/avatars/1.png')

  const [contacts, setContacts] = useState(false)
  const [fetchLoading, setFetchLoading] = useState(true)

  const callHandler = () => {
    setChat(false)
    setContacts(false)
    setCalls(true)
  }

  const contactsHandler = () => {
    setChat(false)
    setCalls(false)
    setContacts(true)
  }

  const ChatHandler = () => {
    setChat(true)
    setCalls(false)
    setContacts(false)
  }
  useEffect(() => {
    Promise.allSettled([dispatch(fetchUserProfile()), dispatch(fetchChatsContacts())]).finally(() => {
      setFetchLoading(false)
    })
  }, [dispatch])
  const handleLeftSidebarToggle = () => setLeftSidebarOpen(prev => !prev)
  const handleUserProfileLeftSidebarToggle = () => setUserProfileLeftOpen(prev => !prev)
  const handleUserProfileRightSidebarToggle = () => setUserProfileRightOpen(prev => !prev)

  return (
    <>
      <Box
        className='app-chat'
        sx={{
          width: '100%',
          display: 'flex',
          borderRadius: 1,
          position: 'relative',
          minHeight: 'calc(var(--vh2) * 100 - 90px)',
          boxShadow: skin === 'bordered' ? 0 : 6,
          ...(skin === 'bordered' && { border: `1px solid ${theme.palette.divider}` })
        }}
      >
        {fetchLoading ? (
          <ContentLoading />
        ) : (
          <>
        <LineSideBar
          store={store}
          hidden={hidden}
          mdAbove={mdAbove}
          dispatch={dispatch}
          userStatus={userStatus}
          selectMessage={selectMessage}
          getInitials={getInitials}
          sidebarWidth={sidebarWidth}
          setUserStatus={setUserStatus}
          leftSidebarOpen={leftSidebarOpen}
          removeSelectedChat={removeSelectedChat}
          userProfileLeftOpen={userProfileLeftOpen}
          formatDateToMonthShort={formatDateToMonthShort}
          handleLeftSidebarToggle={handleLeftSidebarToggle}
          handleUserProfileLeftSidebarToggle={handleUserProfileLeftSidebarToggle}
          calls={calls}
          setCalls={setCalls}
          headImg={headImg}
          setChat={setChat}
          chat={chat}
          setHaedImg={setHaedImg}
          setContacts={setContacts}
        />
        {chat && (
          <LineContent
            store={store}
            hidden={hidden}
            mdAbove={mdAbove}
            dispatch={dispatch}
            getInitials={getInitials}
            sidebarWidth={sidebarWidth}
            userProfileRightOpen={userProfileRightOpen}
            handleLeftSidebarToggle={handleLeftSidebarToggle}
            handleUserProfileRightSidebarToggle={handleUserProfileRightSidebarToggle}
            headImg={headImg}
            setHaedImg={setHaedImg}
          />
        )}

        {chat === false ? (
          <LineContacts
            store={store}
            hidden={hidden}
            mdAbove={mdAbove}
            dispatch={dispatch}
            getInitials={getInitials}
            sidebarWidth={sidebarWidth}
            userProfileRightOpen={userProfileRightOpen}
            handleLeftSidebarToggle={handleLeftSidebarToggle}
            handleUserProfileRightSidebarToggle={handleUserProfileRightSidebarToggle}
            setCalls={setCalls}
            headImg={headImg}
            setHaedImg={setHaedImg}
            setContacts={setContacts}
            callData={callData}
          />
        )
          : ''
        }
          </>
        )}
      </Box>
    </>
  )
}

Facebook.contentHeightFixed = true

export default Facebook
